import createAutoRerunFunctionIfFailed from '@resources/js/helpers/create-auto-rerun-function-if-failed'
import api from '@resources/js/http/api'

const REQUEST_TYPES = {
	start: '/api/availability/start/',
	status: '/api/availability/status/',
	result: '/api/availability/result/',
}

const ERROR_MESSAGES = {
	start: 'Request failed: cannot start availability check',
	unsuccessfulStart: 'Unsuccessful availability start',
	status: 'Request failed: cannot get availability status',
	unsuccessfulStatus: 'Unsuccessful availability status',
	statusNotFinished: "Request failed: status is not 'finish'",
	result: 'Request failed: cannot fetch availability result',
	unsuccessfulResult: 'Unsuccessful availability result',
}

const startCheckAvailRequest = async (params = {}) => {
	try {
		const response = await api.get(REQUEST_TYPES.start, { params })

		if (!response.data.success) throw new Error(ERROR_MESSAGES.unsuccessfulStart)

		const parsedRes = response.data

		return { id: parsedRes.id }
	} catch (err) {
		console.error(ERROR_MESSAGES.start, err)
		throw err
	}
}

const getCheckAvailStatusRequest = async id => {
	try {
		const response = await api.get(REQUEST_TYPES.status, {
			params: { av_id: id },
		})
		const parsedRes = response.data

		if (parsedRes.status !== 'finish')
			throw new Error(ERROR_MESSAGES.statusNotFinished)

		if (!response.data.success)
			throw new Error(ERROR_MESSAGES.unsuccessfulStatus)

		return parsedRes
	} catch (err) {
		console.error(ERROR_MESSAGES.status, err)
		throw err
	}
}

const fetchAvailResultRequest = async (params = {}) => {
	try {
		const response = await api.get(REQUEST_TYPES.result, { params })

		if (!response.data.success)
			throw new Error(ERROR_MESSAGES.unsuccessfulResult)

		return response.data
	} catch (err) {
		console.error(ERROR_MESSAGES.result, err)
		throw err
	}
}

// Створюємо обгортки для функцій для варіантів, коли треба перезапускати
export const startCheckAvail = createAutoRerunFunctionIfFailed(
	startCheckAvailRequest
)
export const getCheckAvailStatus = createAutoRerunFunctionIfFailed(
	getCheckAvailStatusRequest
)
export const fetchAvailResult = createAutoRerunFunctionIfFailed(
	fetchAvailResultRequest
)
